export const rateListFromDto = (dto) => ({
  id: dto.id,
  percentage: dto.percentage,
  active: dto.active,
});

export const rateFromDto = (dto) => ({
  ...rateListFromDto(dto),
  agreement_plan: dto.agreement_plan,
  rule_groups: dto.rule_groups, // TODO: Mapear
});

export const rateCreateToDto = (data) => ({
  percentage: data.percentage,
});

export const rateUpdateToDto = (data) => ({
  ...rateCreateToDto(data), // Reutiliza los campos de creación y deja preparado el objeto para añadir campos específicos al actualizar
});
